export default "__VITE_ASSET__W2N4F1Wq__"